// ActionTypes
const UPDATE_SHOW_BREAD_CRUMBS = 'UPDATE_SHOW_BREAD_CRUMBS';

// actionCreater
export function hideBreadCrumbs() {
  return {
    type: UPDATE_SHOW_BREAD_CRUMBS,
    payload: false,
  };
}

export function showBreadCrumbs() {
  return {
    type: UPDATE_SHOW_BREAD_CRUMBS,
    payload: true,
  };
}

export default (state = { show: true }, action) => {
  const { type, payload } = action;

  switch (type) {
    case UPDATE_SHOW_BREAD_CRUMBS:
      return Object.assign({}, state, { show: payload });
    default:
      return state;
  }
};
